(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-popup"] && !Shopify.designMode) return;
  try {
    // Search popup functionality
  (function () {
    // Wait for DOM to be ready
    function initSearchPopup() {
      var searchToggle = document.querySelector('[data-search-toggle]');
      var searchOverlay = document.querySelector('[data-search-overlay]');
      var searchPanel = document.querySelector('[data-search-panel]');
      var searchClose = document.querySelector('[data-search-close]');
      var searchInput = document.querySelector('[data-search-input]');
      var searchResults = document.querySelector('[data-search-results]');
      var searchSuggestions = document.querySelector('[data-search-suggestions]');
      var searchSuggestionsBtns = document.querySelectorAll('[data-suggestion]');

      // Debug logging
      console.log('Search popup elements found:', {
        searchToggle: !!searchToggle,
        searchOverlay: !!searchOverlay,
        searchPanel: !!searchPanel,
        searchClose: !!searchClose,
        searchInput: !!searchInput,
      });

      if (!searchToggle || !searchOverlay || !searchPanel) {
        console.error('Search popup elements not found');
        return;
      }

      console.log('All search popup elements found, setting up event listeners');

      var searchTimeout;
      var isSearching = false;

      function openSearchPopup() {
        console.log('Opening search popup');
        console.log('Search overlay element:', searchOverlay);
        console.log('Search overlay classes before:', searchOverlay.className);

        // Use setProperty with important to override any previous !important styles
        searchOverlay.style.setProperty('display', 'block', 'important');
        searchOverlay.style.setProperty('opacity', '1', 'important');
        searchOverlay.style.setProperty('pointer-events', 'auto', 'important');
        searchOverlay.classList.add('active');

        console.log('Search overlay classes after:', searchOverlay.className);
        document.body.style.overflow = 'hidden';

        // Ensure close button is accessible
        var currentCloseButton = document.querySelector('[data-search-close]');
        if (currentCloseButton && currentCloseButton !== searchClose) {
          console.log('Close button reference updated');
          searchClose = currentCloseButton;
          // Re-attach event listener if needed
          currentCloseButton.addEventListener('click', function (e) {
            console.log('Close button clicked via event listener (re-attached)');
            e.preventDefault();
            e.stopPropagation();
            closeSearchPopup();
          });
        }

        // Focus on search input after animation
        setTimeout(function () {
          if (searchInput) {
            searchInput.focus();
          }
        }, 200);
      }

      function closeSearchPopup() {
        console.log('Closing search popup');
        console.log('Search overlay before close:', searchOverlay);
        console.log('Has active class:', searchOverlay.classList.contains('active'));

        // Remove active class
        searchOverlay.classList.remove('active');

        // Force hide with !important to override CSS
        searchOverlay.style.setProperty('display', 'none', 'important');
        searchOverlay.style.setProperty('opacity', '0', 'important');
        searchOverlay.style.setProperty('pointer-events', 'none', 'important');

        document.body.style.overflow = '';
        if (searchInput) {
          searchInput.value = '';
        }
        clearSearchResults();

        console.log('Search overlay after close:', searchOverlay);
        console.log('Has active class:', searchOverlay.classList.contains('active'));
      }

      function clearSearchResults() {
        if (searchResults) {
          searchResults.innerHTML = '';
        }
        if (searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      }

      function showSearchResults(results) {
        console.log('showSearchResults called with:', results);
        if (!searchResults || !searchSuggestions) {
          console.error('searchResults or searchSuggestions not found');
          return;
        }

        searchSuggestions.style.display = 'none';

        if (results.length === 0) {
          console.log('No results to show');
          searchResults.innerHTML =
            '<div class="text-center py-8" style="color: var(--color-primary, #333333); opacity: 0.7;">No results found</div>';
          return;
        }

        // Get the current search query
        var currentQuery = searchInput ? searchInput.value.trim() : '';

        var resultsHtml =
          '<div class="mb-4 pb-3 border-b" style="border-color: var(--color-foreground, #EEEAE2);">' +
          '<h3 class="text-sm font-medium" style="color: var(--color-primary, #333333);">Search Results for "' +
          currentQuery +
          '"</h3>' +
          '<p class="text-xs mt-1" style="color: var(--color-primary, #333333); opacity: 0.7;">Found ' +
          results.length +
          ' results</p>' +
          '</div>';
        results.forEach(function (result) {
          var imageHtml = '';
          if (result.image) {
            imageHtml = '<img src="' + result.image + '" alt="' + result.title + '" class="search-result-image">';
          } else {
            imageHtml =
              '<div class="search-result-image flex items-center justify-center" style="background-color: var(--color-foreground, #EEEAE2);"><svg class="w-6 h-6" style="color: var(--color-primary, #333333); opacity: 0.5;" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg></div>';
          }

          var priceHtml = '';
          if (result.price) {
            priceHtml = '<div class="search-result-price">' + result.price + '</div>';
          }

          resultsHtml +=
            '<a href="' +
            result.url +
            '" class="search-result-item">' +
            imageHtml +
            '<div class="search-result-content">' +
            '<div class="search-result-title">' +
            result.title +
            '</div>' +
            '<div class="search-result-type">' +
            result.type +
            '</div>' +
            priceHtml +
            '</div>' +
            '</a>';
        });

        // Add action buttons at the bottom
        if (results.length > 0) {
          resultsHtml +=
            '<div class="border-t pt-4 mt-4 space-y-2" style="border-color: var(--color-foreground, #EEEAE2);">' +
            '<a href="/search?q=' +
            encodeURIComponent(currentQuery) +
            '" class="block text-center py-2 px-4 rounded-lg transition-colors" style="background-color: #a3b18a; color: #ffffff;" onmouseover="this.style.backgroundColor=\'#8a9870\';" onmouseout="this.style.backgroundColor=\'#a3b18a\';">' +
            'View All Results (' +
            results.length +
            ')' +
            '</a>' +
            '<button onclick="clearSearchResults(); if(searchInput) searchInput.value = \'\';" class="w-full py-2 px-4 transition-colors" style="color: var(--color-primary, #333333); opacity: 0.7;" onmouseover="this.style.opacity=\'1\';" onmouseout="this.style.opacity=\'0.7\';">' +
            'Clear Search' +
            '</button>' +
            '</div>';
        }

        searchResults.innerHTML = resultsHtml;
      }

      function performSearch(query) {
        console.log('performSearch called with query:', query);
        if (!query || query.length < 2) {
          console.log('Query too short, clearing results');
          clearSearchResults();
          return;
        }

        if (isSearching) {
          console.log('Already searching, skipping');
          return;
        }
        isSearching = true;
        console.log('Starting search for:', query);

        // Show loading state
        if (searchResults) {
          searchResults.innerHTML =
            '<div class="text-center py-8" style="color: var(--color-primary, #333333); opacity: 0.7;">Searching...</div>';
        }

        // Use Shopify's search API - get more results for better display
        var searchUrl =
          '/search/suggest.json?q=' +
          encodeURIComponent(query) +
          '&resources[type]=product,collection,page,article&resources[limit]=12&resources[limit_scope]=each';
        console.log('Fetching from URL:', searchUrl);

        fetch(searchUrl)
          .then(function (response) {
            console.log('Search response status:', response.status);
            return response.json();
          })
          .then(function (data) {
            console.log('Search API response:', data);
            var results = [];

            // Process products
            if (data.resources && data.resources.results && data.resources.results.products) {
              data.resources.results.products.forEach(function (product) {
                results.push({
                  title: product.title,
                  url: product.url,
                  image: product.image,
                  price: product.price ? product.price + ' €' : '',
                  type: 'Product',
                });
              });
            }

            // Process collections
            if (data.resources && data.resources.results && data.resources.results.collections) {
              data.resources.results.collections.forEach(function (collection) {
                results.push({
                  title: collection.title,
                  url: collection.url,
                  image: collection.image,
                  price: '',
                  type: 'Collection',
                });
              });
            }

            // Process pages
            if (data.resources && data.resources.results && data.resources.results.pages) {
              data.resources.results.pages.forEach(function (page) {
                results.push({
                  title: page.title,
                  url: page.url,
                  image: '',
                  price: '',
                  type: 'Page',
                });
              });
            }

            // Process articles
            if (data.resources && data.resources.results && data.resources.results.articles) {
              data.resources.results.articles.forEach(function (article) {
                results.push({
                  title: article.title,
                  url: article.url,
                  image: article.image || '',
                  price: '',
                  type: 'Article',
                });
              });
            }

            console.log('Final results array:', results);
            console.log('Number of results:', results.length);
            showSearchResults(results);
            isSearching = false;
          })
          .catch(function (error) {
            console.error('Search error:', error);
            if (searchResults) {
              searchResults.innerHTML =
                '<div class="text-center py-8" style="color: #DC2626;">Search failed. Please try again.</div>';
            }
            isSearching = false;
          });
      }

      // Event listeners
      searchToggle.addEventListener('click', function (e) {
        console.log('Search toggle clicked');
        e.preventDefault();
        e.stopPropagation();
        openSearchPopup();
      });

      if (searchClose) {
        console.log('Setting up close button event listener');
        searchClose.addEventListener('click', function (e) {
          console.log('Close button clicked via event listener');
          e.preventDefault();
          e.stopPropagation();
          closeSearchPopup();
        });
      } else {
        console.error('Close button not found!');
      }

      // Close on overlay click (but not when clicking inside the panel)
      // Don't stop propagation on the close button itself
      if (searchPanel) {
        searchPanel.addEventListener('click', function (e) {
          // Allow close button clicks to work
          if (e.target.closest('[data-search-close]')) {
            return;
          }
          e.stopPropagation();
        });
      }

      searchOverlay.addEventListener('click', function (e) {
        if (e.target === searchOverlay) {
          closeSearchPopup();
        }
      });

      // Close on escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
          closeSearchPopup();
        }
      });

      // Search input functionality
      if (searchInput) {
        searchInput.addEventListener('input', function () {
          var query = this.value.trim();
          console.log('Input event triggered, query:', query);

          clearTimeout(searchTimeout);
          searchTimeout = setTimeout(function () {
            console.log('About to perform search for:', query);
            performSearch(query);
          }, 300);
        });

        // Handle form submission - show results in popup instead of redirecting
        var searchForm = searchInput.closest('form');
        if (searchForm) {
          searchForm.addEventListener('submit', function (e) {
            console.log('Form submitted');
            e.preventDefault();
            e.stopPropagation();
            var query = searchInput.value.trim();
            console.log('Form query:', query);
            if (query) {
              performSearch(query);
            }
            return false;
          });
        }

        // Handle Enter key on input field
        searchInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            console.log('Enter key pressed');
            e.preventDefault();
            e.stopPropagation();
            var query = this.value.trim();
            console.log('Enter key query:', query);
            if (query) {
              performSearch(query);
            }
          }
        });
      }

      // Search suggestion buttons - let them work as normal links
      console.log('Number of suggestion buttons found:', searchSuggestionsBtns.length);

      console.log('Search popup setup complete');

      // Make performSearch globally accessible
      window.performSearch = performSearch;
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSearchPopup);
    } else {
      initSearchPopup();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
